import { render, staticRenderFns } from "./page31.vue?vue&type=template&id=745fae4d&scoped=true&"
import script from "./page31.vue?vue&type=script&lang=js&"
export * from "./page31.vue?vue&type=script&lang=js&"
import style0 from "./page31.vue?vue&type=style&index=0&id=745fae4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745fae4d",
  null
  
)

export default component.exports